// Page: Integrations

if ($('body').hasClass('page--team')) {

  let $body = $(document.body);
  let $anchorHeader = $('.team__feature-headline', $body);
  let hash = window.location.hash;
  let stickyHeaderHeight = 62;

  if(hash) {
    $anchorHeader.each(function(){
      if (hash === ($(this).attr("data-anchor"))) {
        let $scrollPosition = $( this ).parent().offset().top;
        $("html, body").scrollTop($scrollPosition - stickyHeaderHeight);
      }
    });
  }
}
